import * as React from "react";
const WaterSanitationAndHygieneIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 56 56",
  "aria-hidden": "true",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#water-sanitation-and-hygiene_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M46.32 35.166C47.564 36.86 52 43.117 52 45.976a6 6 0 1 1-12 0c0-2.859 4.436-9.116 5.68-10.81a.392.392 0 0 1 .64 0ZM6 5h3a2 2 0 0 1 2 2v5h12V7h-4.5a1.5 1.5 0 0 1 0-3h14a1.5 1.5 0 0 1 0 3H28v5h10.147A11.865 11.865 0 0 1 50 23.853V26h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H41a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1v-2.147A3.857 3.857 0 0 0 38.147 20H11v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "water-sanitation-and-hygiene_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h56v56H0z"
}))));
export default WaterSanitationAndHygieneIcon;